import { useEffect } from 'react';
import { useRequest } from 'domain/core/hooks/useRequest';
import { ApiMethodsEnum } from 'infrastructure/enums/ApiMethodsEnum';
import { debounce } from 'lodash';

export const useGetCurrentLocation = (limit: number, page: number, filter: string) => {
  const { data, isLoading, error, send } = useRequest({
    url: `/api/v1/location?limit=${limit}&page=${page}&filter[name][contains]=${filter}`,
    method: ApiMethodsEnum.Get,
    sendOnStart: false,
  });

  const debouncedSend = debounce(() => {
    send();
  }, 500);

  useEffect(() => {
    if (filter.trim() !== '') {
      debouncedSend();
    }

    return () => {
      return debouncedSend.cancel();
    };
  }, [filter, page]);

  return {
    data,
    isLoading,
    error,
  };
};
